
          window.global = window;
        